import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  href?: string;
}

const sizes = {
  sm: { grid: 20, gap: 2, radius: 2, text: 'text-[15px]', ml: 'ml-1.5' },
  md: { grid: 24, gap: 2.5, radius: 2, text: 'text-lg', ml: 'ml-2' },
  lg: { grid: 32, gap: 3, radius: 2.5, text: 'text-2xl', ml: 'ml-2.5' },
  xl: { grid: 42, gap: 3.5, radius: 3, text: 'text-3xl', ml: 'ml-3' },
};

export const MosaicMark: React.FC<{ size?: 'sm' | 'md' | 'lg' | 'xl' }> = ({ size = 'md' }) => {
  const s = sizes[size];
  const tileSize = (s.grid - s.gap) / 2;

  return (
    <svg
      width={s.grid}
      height={s.grid}
      viewBox={`0 0 ${s.grid} ${s.grid}`}
      fill="none"
      className="flex-shrink-0"
    >
      {/* Top-left: teal */}
      <rect x={0} y={0} width={tileSize} height={tileSize} rx={s.radius} fill="var(--accent-primary)" />
      {/* Top-right: neutral */}
      <rect x={tileSize + s.gap} y={0} width={tileSize} height={tileSize} rx={s.radius} fill="var(--mosaic-dark)" />
      {/* Bottom-left: neutral */}
      <rect x={0} y={tileSize + s.gap} width={tileSize} height={tileSize} rx={s.radius} fill="var(--mosaic-dark)" />
      {/* Bottom-right: teal */}
      <rect x={tileSize + s.gap} y={tileSize + s.gap} width={tileSize} height={tileSize} rx={s.radius} fill="var(--accent-primary)" />
    </svg>
  );
};

export const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '', href }) => {
  const s = sizes[size];

  const content = (
    <>
      <MosaicMark size={size} />
      {showText && (
        <span className={`${s.text} ${s.ml} font-semibold tracking-tight text-[var(--content-primary)]`}>
          Mozayc
        </span>
      )}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        onClick={(e) => { e.preventDefault(); window.history.pushState(null, '', href); window.dispatchEvent(new PopStateEvent('popstate')); }}
        className={`inline-flex items-center cursor-pointer hover:opacity-80 transition-opacity ${className}`}
      >
        {content}
      </a>
    );
  }

  return (
    <span className={`inline-flex items-center ${className}`}>
      {content}
    </span>
  );
};
